
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, tuple_type, list_type, class_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { DataTransferObject_AddNotificationImageDto, ImageRole, alreadyDecidedValidationMessage, DataTransferObject_RejectAssignmentNotificationDto, DataTransferObject_WithdrawAssignmentNotificationDto, AssignmentNotificationId, AssignmentNotificationId_$reflection, EntityType_$reflection, AssignmentNotification_$reflection } from "../../Shared/AssignmentNotification.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1, NotificationId__get_unwrap, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { ImageUpload, DnDFormImage_$reflection } from "../Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { OverviewNotification_$reflection } from "../../Shared/Notification.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { addImage, removeImage, rejectNotification, withdrawNotification, getNotificationDetail } from "../../Requests/AssignmentNotification.js";
import { add, tryFind, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { createObj, comparePrimitives, equals, compareArrays } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { difference, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { singleton as singleton_1, map as map_1, isEmpty, filter, ofArray, tryFind as tryFind_1, tryPick, empty as empty_1, choose } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { collect, singleton, empty as empty_2, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Cmd_uploadImage } from "../../Requests/Files.js";
import { receiverFilesByEntity } from "../Helper.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextValue } from "../../Components/Text.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ClickableImageStrip } from "../Image/ImageStrip.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";

export class DialogMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RejectByReceiver", "AbortBySender"];
    }
}

export function DialogMode_$reflection() {
    return union_type("Widgets.RejectNotificationDialog.DialogMode", [], DialogMode, () => [[], []]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DetailLoaded", "AbortNotification", "RejectNotification", "NotificationRequestResponse", "FetchError", "SetSelectedReceiverFiles", "ReceiverImageUploaded", "ReceiverImageRegistered", "ReceiverImageRemoved"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.RejectNotificationDialog.Msg", [], Msg, () => [[["Item", AssignmentNotification_$reflection()]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]], [["Item1", EntityType_$reflection()], ["Item2", string_type], ["Item3", list_type(DnDFormImage_$reflection())]], [["Item1", EntityType_$reflection()], ["Item2", string_type], ["Item3", FileUploadResponse_$reflection()]], [["Item", ClientApiResponse$1_$reflection(class_type("System.Guid"))]], [["Item", ClientApiResponse$1_$reflection(string_type)]]]);
}

class State extends Record {
    constructor(Notification, AssignmentNotificationId, Detail, SelectedReceiverFilesByEntity, FormState, OnConfirm, Mode) {
        super();
        this.Notification = Notification;
        this.AssignmentNotificationId = AssignmentNotificationId;
        this.Detail = Detail;
        this.SelectedReceiverFilesByEntity = SelectedReceiverFilesByEntity;
        this.FormState = FormState;
        this.OnConfirm = OnConfirm;
        this.Mode = Mode;
    }
}

function State_$reflection() {
    return record_type("Widgets.RejectNotificationDialog.State", [], State, () => [["Notification", OverviewNotification_$reflection()], ["AssignmentNotificationId", AssignmentNotificationId_$reflection()], ["Detail", RequestedValue$1_$reflection(AssignmentNotification_$reflection())], ["SelectedReceiverFilesByEntity", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(EntityType_$reflection(), string_type), list_type(DnDFormImage_$reflection())])], ["FormState", FormState_$reflection()], ["OnConfirm", lambda_type(unit_type, unit_type)], ["Mode", DialogMode_$reflection()]]);
}

function assignmentIdOf(notification) {
    return new AssignmentNotificationId(parse(NotificationId__get_unwrap(notification.Id)));
}

function loadDetailCmd(id) {
    return getNotificationDetail(id, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(4, [Item_1])));
}

function init(notification, onConfirm, mode) {
    const id = assignmentIdOf(notification);
    return [new State(notification, id, new RequestedValue$1(0, []), empty({
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }), FormState_get_empty(), onConfirm, mode), loadDetailCmd(id)];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, FormState__startLoading(state.FormState), state.OnConfirm, state.Mode), withdrawNotification(state.AssignmentNotificationId, new DataTransferObject_WithdrawAssignmentNotificationDto(undefined), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
        case 2:
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, FormState__startLoading(state.FormState), state.OnConfirm, state.Mode), rejectNotification(state.AssignmentNotificationId, new DataTransferObject_RejectAssignmentNotificationDto(undefined), (Item_2) => (new Msg(3, [Item_2])), (Item_3) => (new Msg(4, [Item_3])))];
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                if (equals(response.fields[0].GlobalValidationMessage, alreadyDecidedValidationMessage)) {
                    state.OnConfirm();
                    return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, FormState_get_empty(), state.OnConfirm, state.Mode), Cmd_errorToast(alreadyDecidedValidationMessage)];
                }
                else {
                    return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.OnConfirm, state.Mode), Cmd_none()];
                }
            }
            else {
                state.OnConfirm();
                return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, FormState_get_empty(), state.OnConfirm, state.Mode), Cmd_none()];
            }
        }
        case 4:
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, state.SelectedReceiverFilesByEntity, FormState_get_empty(), state.OnConfirm, state.Mode), Cmd_none()];
        case 5: {
            const newFiles = msg.fields[2];
            const entityType = msg.fields[0];
            const entityId = msg.fields[1];
            const entityKey = [entityType, entityId];
            const previousUrls = ofList(choose((f) => {
                if (f.tag === 1) {
                    return f.fields[0].ImageUrl;
                }
                else {
                    return undefined;
                }
            }, defaultArg(tryFind(entityKey, state.SelectedReceiverFilesByEntity), empty_1())), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            });
            const newUrls = ofList(choose((f_1) => {
                if (f_1.tag === 1) {
                    return f_1.fields[0].ImageUrl;
                }
                else {
                    return undefined;
                }
            }, newFiles), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            });
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            const removedUrls = difference(previousUrls, newUrls);
            const cmds = toList(delay(() => {
                let matchValue_1, file, formData;
                return append((matchValue_1 = pickedFile, (matchValue_1 == null) ? (empty_2()) : ((file = matchValue_1, (formData = (new FormData()), (formData.append(file.name, file), singleton(Cmd_uploadImage((r) => (new Msg(6, [entityType, entityId, r])), (Item_4) => (new Msg(4, [Item_4])), formData))))))), delay(() => collect((url_1) => {
                    let matchValue_2;
                    const matchValue = state.Detail;
                    matchValue_2 = ((matchValue.tag === 0) ? undefined : map((i_1) => i_1.Id, tryFind_1((i) => {
                        if ((equals(i.Role, new ImageRole(1, [])) && equals(i.EntityType, entityType)) && (i.EntityId === entityId)) {
                            return i.ImageUrl === url_1;
                        }
                        else {
                            return false;
                        }
                    }, matchValue.fields[0].Images)));
                    if (matchValue_2 == null) {
                        return empty_2();
                    }
                    else {
                        return singleton(removeImage(state.AssignmentNotificationId, matchValue_2, (Item_5) => (new Msg(8, [Item_5])), (Item_6) => (new Msg(4, [Item_6]))));
                    }
                }, removedUrls)));
            }));
            return [new State(state.Notification, state.AssignmentNotificationId, state.Detail, add(entityKey, newFiles, state.SelectedReceiverFilesByEntity), state.FormState, state.OnConfirm, state.Mode), Cmd_batch(cmds)];
        }
        case 6: {
            const response_1 = msg.fields[2];
            switch (response_1.tag) {
                case 0:
                    return [state, Cmd_batch(ofArray([loadDetailCmd(state.AssignmentNotificationId), Cmd_errorToast("general.file_too_large")]))];
                case 2:
                    return [state, Cmd_batch(ofArray([loadDetailCmd(state.AssignmentNotificationId), Cmd_errorToast("general.a_error_occured")]))];
                default:
                    return [state, addImage(state.AssignmentNotificationId, new DataTransferObject_AddNotificationImageDto(msg.fields[0], msg.fields[1], new ImageRole(1, []), response_1.fields[0].ImageUrl), (Item_7) => (new Msg(7, [Item_7])), (Item_8) => (new Msg(4, [Item_8])))];
            }
        }
        case 7:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_batch(ofArray([loadDetailCmd(state.AssignmentNotificationId), Cmd_errorToast("general.a_error_occured")]))];
            }
            else {
                return [state, loadDetailCmd(state.AssignmentNotificationId)];
            }
        case 8:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_batch(ofArray([loadDetailCmd(state.AssignmentNotificationId), Cmd_errorToast("general.a_error_occured")]))];
            }
            else {
                return [state, loadDetailCmd(state.AssignmentNotificationId)];
            }
        default: {
            const detail = msg.fields[0];
            return [new State(state.Notification, state.AssignmentNotificationId, new RequestedValue$1(1, [detail]), receiverFilesByEntity(detail), state.FormState, state.OnConfirm, state.Mode), Cmd_none()];
        }
    }
}

function DialogBody(props) {
    let elems_13;
    const t = useTranslation()[0];
    let entities;
    const matchValue = props.Detail;
    entities = ((matchValue.tag === 0) ? empty_1() : matchValue.fields[0].Entities);
    const imagesForEntity = (role, entityType, entityId) => {
        const matchValue_1 = props.Detail;
        if (matchValue_1.tag === 0) {
            return empty_1();
        }
        else {
            return filter((i) => {
                if (equals(i.Role, role) && equals(i.EntityType, entityType)) {
                    return i.EntityId === entityId;
                }
                else {
                    return false;
                }
            }, matchValue_1.fields[0].Images);
        }
    };
    return reactElement("div", createObj(singleton_1((elems_13 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], (elems = [createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: props.Description,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2, elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_2 = [reactElement("div", {
                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                children: t("general.sender"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "normal",
                TestId: "",
                Text: props.Notification.Sender,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_4, elems_3;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [reactElement("div", {
                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                    children: t("general.receiver"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_3 = [createElement(TextValue, {
                    FontWeight: "normal",
                    TestId: "",
                    Text: props.Notification.Receiver,
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let elems_6, elems_5;
                    return append((props.Notification.Comment !== "") ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_6 = [reactElement("div", {
                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                        children: t("general.comment"),
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_5 = [createElement(TextValue, {
                        FontWeight: "normal",
                        TestId: "",
                        Text: props.Notification.Comment,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty_2(), delay(() => {
                        let matchValue_2, plannedReturnDate, elems_8, elems_7;
                        return append((matchValue_2 = props.Notification.PlannedReturnDate, (matchValue_2 == null) ? (empty_2()) : ((plannedReturnDate = matchValue_2, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_8 = [reactElement("div", {
                            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                            children: t("tool.planned_return_date"),
                        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_7 = [createElement(TextValue, {
                            FontWeight: "normal",
                            TestId: "",
                            Text: toString(toLocalTime(plannedReturnDate), "dd.MM.yyyy"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))))))), delay(() => append(collect((entity) => {
                            let elems_12;
                            const entitySenderImages = imagesForEntity(new ImageRole(0, []), entity.EntityType, entity.EntityId);
                            const entityReceiverImages = imagesForEntity(new ImageRole(1, []), entity.EntityType, entity.EntityId);
                            const receiverFiles = defaultArg(tryFind([entity.EntityType, entity.EntityId], props.SelectedReceiverFilesByEntity), empty_1());
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_12 = toList(delay(() => {
                                let elems_9;
                                return append(!isEmpty(entitySenderImages) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_9 = [reactElement("div", {
                                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                    children: t("assignment_notification.sender_images"),
                                }), createElement(ClickableImageStrip, {
                                    ImageClasses: ofArray(["h-20", "w-20"]),
                                    Images: map_1((image) => ({
                                        Url: image.ImageUrl,
                                    }), entitySenderImages),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty_2(), delay(() => {
                                    let elems_11, elems_10;
                                    return (props.Mode.tag === 1) ? (!isEmpty(entityReceiverImages) ? singleton(reactElement("div", createObj(singleton_1((elems_11 = [reactElement("div", {
                                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                        children: t("assignment_notification.receiver_images"),
                                    }), createElement(ClickableImageStrip, {
                                        ImageClasses: ofArray(["h-20", "w-20"]),
                                        Images: map_1((image_1) => ({
                                            Url: image_1.ImageUrl,
                                        }), entityReceiverImages),
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_11))]))))) : empty_2()) : singleton(reactElement("div", createObj(singleton_1((elems_10 = [reactElement("div", {
                                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                        children: t("assignment_notification.receiver_images"),
                                    }), createElement(ImageUpload, {
                                        ComponentState: props.ComponentState,
                                        SelectedFiles: receiverFiles,
                                        SetSelectedFile: (files) => {
                                            props.Dispatch(new Msg(5, [entity.EntityType, entity.EntityId, files]));
                                        },
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_10))])))));
                                }));
                            })), ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
                        }, entities), delay(() => {
                            const matchValue_4 = FormState__getValidation(props.FormState, t, "global");
                            if (matchValue_4 == null) {
                                return empty_2();
                            }
                            else {
                                return singleton(createElement(ErrorAlert, {
                                    Label: matchValue_4,
                                }));
                            }
                        }))));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_13))]))));
}

export function RejectNotificationDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Notification, props.OnConfirm, new DialogMode(0, [])), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("notification.reject"), {
        Body: singleton_1(createElement(DialogBody, {
            ComponentState: componentState,
            Description: props.Description,
            Detail: state_1.Detail,
            Dispatch: dispatch,
            FormState: state_1.FormState,
            Mode: new DialogMode(0, []),
            Notification: props.Notification,
            SelectedReceiverFilesByEntity: state_1.SelectedReceiverFilesByEntity,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-accept-notification-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("notification.reject"),
            OnClick: () => {
                dispatch(new Msg(2, []));
            },
            TestId: "accept-notification-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

export function AbortNotificationDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Notification, props.OnConfirm, new DialogMode(1, [])), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("general.cancel"), {
        Body: singleton_1(createElement(DialogBody, {
            ComponentState: componentState,
            Description: props.Description,
            Detail: state_1.Detail,
            Dispatch: dispatch,
            FormState: state_1.FormState,
            Mode: new DialogMode(1, []),
            Notification: props.Notification,
            SelectedReceiverFilesByEntity: state_1.SelectedReceiverFilesByEntity,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-accept-notification-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("notification.reject"),
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "accept-notification-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

